// ---- Action types ----
export const CHANGE_ACTIVE_ITEM_TS_EXPERT = "CH_TS_EXPERT";
export const CHANGE_ACTIVE_ITEM_LIVELIST = "CH_LL";
export const CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX = "CH_LL_MATRIX";
export const CHANGE_ACTIVE_ITEM_OSCILLOSCOPE = "CH_OSCILLOSCOPE";
export const CHANGE_ACTIVE_ITEM_BAR_GRAPH = "CH_BARGRAPH";
export const CHANGE_ACTIVE_ITEM_DADOS = "CH_DADOS";
export const CHANGE_ACTIVE_ITEM_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_REPORT = "CH_REPORT";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
// ---- Channels ----
export const CHANGE_ACTIVE_ITEM_CHANNEL = "CH_CHANNEL";
// ---- Solve Problem ----
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
